var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiniment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "liniment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "background",
    d: "M17 0H23L25 9H15L17 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "background",
    d: "M12 10H28L27 33L28 40H12L13 33L12 10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 9L21 0H23L25 9H23Z",
    fill: "black",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 31L26 10H28L27 33L25 31Z",
    fill: "black",
    fillOpacity: 0.25
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 14",
    d: "M13 33H27L25 31H14L13 33Z",
    fill: "black",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 18",
    d: "M14 31L13.5 11.5L12.0219 10.0219L13 33L14 31Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 15",
    d: "M13 33H27L25 35H14L13 33Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 17",
    d: "M14 35L13 33L12 40H13.5L14 35Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 16",
    d: "M25 35L27 33L28 40H26L25 35Z",
    fill: "black",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 19",
    d: "M19 0H17L15 9H17L19 0Z",
    fill: "white",
    fillOpacity: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiniment);
export default __webpack_public_path__ + "static/media/liniment.eb1cd564c52dc90628e00acac1267d8c.svg";
export { ForwardRef as ReactComponent };